import { useState } from 'react';

// Simple translation function that returns the original string or a placeholder
export function useTranslation() {
  const [language] = useState('en');
  
  // English translations
  const translations = {
    auth: {
      login: 'Log In',
      signup: 'Sign Up',
      createAccount: 'Create Account',
      welcomeBack: 'Welcome Back',
      loginNow: 'Log in to your account',
      email: 'Email',
      enterEmail: 'Enter your email',
      password: 'Password',
      enterPassword: 'Enter your password',
      confirmPassword: 'Confirm Password',
      confirmYourPassword: 'Confirm your password',
      name: 'Name',
      enterName: 'Enter your name',
      or: 'OR',
      continueWithGoogle: 'Continue with Google',
      continueWithMicrosoft: 'Continue with Microsoft',
      forgotPassword: 'Forgot Password?',
      resetPassword: 'Reset Password',
      resetPasswordPrompt: 'Enter your email to receive a password reset link',
      sendResetLink: 'Send Reset Link',
      backToLogin: 'Back to Login',
      passwordResetEmailSent: 'Password reset email sent. Check your inbox.'
    },
    errors: {
      passwordMatch: 'Passwords do not match',
      passwordRequirements: 'Password does not meet requirements',
      passwordMinLength: 'At least 10 characters',
      passwordUppercase: 'At least one uppercase letter',
      passwordLowercase: 'At least one lowercase letter',
      passwordNumber: 'At least one number',
      passwordSpecial: 'At least one special character'
    },
    common: {
      loading: 'Loading...',
      processing: 'Processing...'
    }
  };
  
  // Translation function
  const translate = (key) => {
    // Split the key by dots to navigate the translations object
    const keys = key.split('.');
    
    // Start with the root translations object
    let result = translations;
    
    // Traverse the object based on the key path
    for (const k of keys) {
      if (result && result[k] !== undefined) {
        result = result[k];
      } else {
        // Key not found, return the original key for development
        return key;
      }
    }
    
    // Return the translation or the key if not found
    return typeof result === 'string' ? result : key;
  };
  
  return translate;
} 